/** Spendable amount balance: excludes flash points and clamps negatives. (RR-300) */
export const spendableAllowanceBalance = (givingBalance: number, flashPointsBalance: number) => Math.max(givingBalance - flashPointsBalance, 0);
